var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { parse } from 'query-string';
import React, { useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { apiGetOneCategoryColumn } from '@/actions/CategoryActionsTs';
import { SideMenuBanner } from '@/components/modules/Layout/SideMenu/SideMenuBanner';
import { SideMenuPopular } from '@/components/modules/Layout/SideMenu/SideMenuPopular/SideMenuPopular';
import { ArticleLinkList } from '@/components/modules/pages/article/List/ArticleLinkList';
import { ArticleListHead } from '@/components/modules/pages/article/Typography/Heading/ArticleListHead';
import { TagButtonList, TagButtonListSkeleton, } from '@/components/ui/List/TagButtonList';
import { SEMINAR_BANNER_IMAGE_URL, SEMINAR_BANNER_SIDE_PC_IMAGE_URL, } from '@/define/consts/assets';
import { propArrayShape, propStr } from '@/helpers/custom-prop-types';
import { useRegistrationCta } from '@/helpers/use/useRegistrationCta';
import { useSessionStorageAction } from '@/hooks/action/sessionStorage/useSessionStorageAction';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { usePopularList } from '@/hooks/pages/list/popular/usePopularList';
import { usePopularListColumnViewData, usePopularListProfessionalViewData, } from '@/hooks/pages/list/popular/usePopularListViewData';
import { useBoolState } from '@/hooks/state/useBoolState';
import { PROFFIT_DEFAULT_OGP } from '@/utils/constants/assets/s3';
import { SESSION_STORAGE_KEY_CATEGORY_COLUMN } from '@/utils/constants/storage/sessionStorageKey';
import { isGuest, isProfessional } from '@/utils/resources/auth/authResource';
import { REGISTRATION_TYPE_COLUMN } from '@/utils/resources/registration/registrationType';
import { getAbsolutePath, myPagePath, seminarListPath, } from '@/utils/router/links';
import useAnalytics from '../../../helpers/use/analytics/useAnalytics';
import GoogleAnalytics from '../../../vendor/GoogleAnalytics';
import Layout from '../../Layout';
import Breadcrumb from '../../Layout/Breadcrumb';
import RegistrationAlertModal from '../../Ui/Modal/RegistrationAlertModal';
import RegistrationCompleteModal from '../../Ui/Modal/RegistrationCompleteModal';
import RegistrationCta from '../../Ui/Registration/RegistrationCta';
import ColumnListUseCase from '../Common/UseCase/ColumnListUseCase';
import ColumnListRow from './ColumnListRow';
export const ColumnList = (props) => {
    const { articleLinkListItems, description, headTitle, title, types } = props;
    const metaTitle = `${title}｜PROFFIT`;
    const dispatch = useDispatch();
    const { pathname, search } = useLocation();
    const unmountRef = useUnmountRef();
    // 現在のqs
    const queryParams = useMemo(() => parse(search), [search]);
    const auth = useSelector((state) => state.auth);
    const isGuestUser = isGuest(auth);
    const isProfessionalUser = isProfessional(auth);
    // 登録モーダル
    const { boolState: showRegistrationModal, changeFalse: hideRegistrationAlert, changeTrue: showRegistrationAlert, } = useBoolState({ initialState: false });
    // カテゴリ：コラム/DL資料
    const { data: storageData, fetchData: fetchColumnThemes, hasInitialData: hasInitialColumnThemes, isLoading: isLoadingColumnThemes, } = useSessionStorageAction({
        apiAction: apiGetOneCategoryColumn,
        dispatch,
        sessionStorageKey: SESSION_STORAGE_KEY_CATEGORY_COLUMN,
        unmountRef,
    });
    const { activeTheme, columnThemes } = useMemo(() => {
        const categories = ((storageData === null || storageData === void 0 ? void 0 : storageData.column_themes) || []).map((category) => ({
            label: category.name,
            value: category.id,
        }));
        return {
            // 選択中のテーマ
            activeTheme: categories.find((theme) => theme.value.toString() === queryParams.theme),
            // テーマ一覧
            columnThemes: categories,
        };
    }, [storageData, queryParams.theme]);
    const pans = useMemo(() => {
        const setPans = [
            {
                text: title,
            },
        ];
        if (!isGuestUser) {
            setPans.unshift({
                link: myPagePath(),
                text: 'マイページ',
            });
        }
        return setPans;
    }, [isGuestUser, title]);
    const locationStateKey = 'articlePageData';
    const { getReplaceUrl, loadColumns, loading, onClickTheme, onLoadMoreColumns, paging, resetState, } = ColumnListUseCase.useColumnListFilter(locationStateKey, dispatch, unmountRef, types);
    const { onClickRegistration } = useAnalytics.useColumn();
    const { hideModal, isShowForm, isShowModal, onSubmitAfter } = useRegistrationCta.useRegistrationCtaForm('column_registration_form', isGuestUser, onClickRegistration);
    useEffect(() => {
        // コラムの読み込み
        const { param, url } = getReplaceUrl(null);
        loadColumns(url, param).then();
        return () => {
            resetState();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);
    // コラムテーマの読み込み
    useEffect(() => {
        if (hasInitialColumnThemes) {
            return;
        }
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            yield fetchColumnThemes();
        }))();
    }, [hasInitialColumnThemes, fetchColumnThemes]);
    const { isLoadingPopularCase, isLoadingPopularColumn, isLoadingPopularProfessional, popularCases, popularConsultantListHasMoreLink, popularProfessionals, populars, } = usePopularList({
        dispatch,
        isGuestUser,
        isProfessionalUser,
        keyword: activeTheme === null || activeTheme === void 0 ? void 0 : activeTheme.label,
        unmountRef,
    });
    // 週間ランキング
    const weeklyRankingList = usePopularListColumnViewData({ populars });
    // 人気のコンサルタント
    const popularConsultantList = usePopularListProfessionalViewData({
        items: popularProfessionals,
    });
    return (_jsxs(Layout, Object.assign({ mainClassName: clsx('l-main', 'column_list_container', 'column_common_container', isGuestUser && 'no-need-bottom-space') }, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: metaTitle }), _jsx("meta", { content: metaTitle, property: 'og:title' }), _jsx("meta", { content: description, name: 'description' }), _jsx("meta", { content: description, property: 'og:description' }), _jsx("meta", { content: 'article', property: 'og:type' }), _jsx("meta", { content: getAbsolutePath(pathname), property: 'og:url' }), _jsx("meta", { content: 'PROFFIT', property: 'og:site_name' }), _jsx("meta", { content: PROFFIT_DEFAULT_OGP, property: 'og:image' })] }), _jsx(Breadcrumb, { lists: pans }), _jsxs("div", Object.assign({ className: clsx('column_container', 'gap-80 lg:gap-48') }, { children: [_jsxs("div", Object.assign({ className: 'column_container_main' }, { children: [_jsx(ArticleLinkList, { className: clsx('w-full', 'mb-16'), items: articleLinkListItems, pathname: pathname }), (() => {
                                // loading
                                if (isLoadingColumnThemes && !columnThemes.length) {
                                    return _jsx(TagButtonListSkeleton, { className: 'mb-24', count: 6 });
                                }
                                // 0件表示
                                if (!columnThemes.length) {
                                    return null;
                                }
                                // 通常表示
                                return (_jsx(TagButtonList, { activeValue: activeTheme === null || activeTheme === void 0 ? void 0 : activeTheme.value, className: 'mb-24', items: columnThemes, onClick: onClickTheme }));
                            })(), _jsx(ArticleListHead, { category: activeTheme === null || activeTheme === void 0 ? void 0 : activeTheme.name, className: 'mb-24', title: (activeTheme === null || activeTheme === void 0 ? void 0 : activeTheme.name) ? headTitle || title : title }), _jsx(ColumnListRow, { articles: paging.articles, loading: loading, onClickMore: onLoadMoreColumns, showMore: paging.articles.length > 0 && !paging.isLastPage, title: title })] })), _jsx(SideMenuPopular, { bannerComponent: _jsx(SideMenuBanner, { gtmSettings: {
                                'data-gtm_category': 'banner',
                                'data-gtm_label': 'column_banner_click',
                                'data-gtm_value': '',
                            }, linkClickEvent: GoogleAnalytics.sendClickEventFromDataAtr, linkTo: seminarListPath(), pcImageSrc: SEMINAR_BANNER_SIDE_PC_IMAGE_URL, spImageSrc: SEMINAR_BANNER_IMAGE_URL }), className: clsx('flex-shrink-0', 'w-full lg:w-[270px]'), isGuestUser: isGuestUser, isLoadingPopularCase: isLoadingPopularCase, isLoadingPopularConsultant: isLoadingPopularProfessional, isLoadingWeeklyRankingList: isLoadingPopularColumn, isProfessionalUser: isProfessionalUser, onClickRegistration: showRegistrationAlert, popularCases: popularCases, popularConsultantList: popularConsultantList, popularConsultantListHasMoreLink: popularConsultantListHasMoreLink, weeklyRankingList: weeklyRankingList, weeklyRankingListLimit: 5 })] })), _jsx(RegistrationAlertModal, { isShow: showRegistrationModal, onClickOther: hideRegistrationAlert, registrationType: REGISTRATION_TYPE_COLUMN }), _jsx(RegistrationCta, { isShow: isShowForm, onSubmitAfter: onSubmitAfter, registrationType: REGISTRATION_TYPE_COLUMN, scrollName: 'column_registration_form' }), _jsx(RegistrationCompleteModal, { hideModal: hideModal, isShow: isShowModal, timeout: 300 })] })));
};
ColumnList.propTypes = {
    /** タブ部分のリンク一覧 */
    articleLinkListItems: propArrayShape().isRequired,
    /** meta description */
    description: propStr(),
    /** 見出しタイトル */
    headTitle: propStr(),
    /** タイトル */
    title: propStr().isRequired,
    /** 検索種別 */
    types: propStr().isRequired,
};
